<template>
    <div class="ecartapi-hero">
        <img class="ecartapi-hero__banner" alt="Ecart API" 
            src="@/assets/images/auth/hero-ecart-api.svg" />
    </div>
</template>

<script>
export default {
    name: 'EcartApiHero',
};
</script>

<style lang="scss">
.ecartapi-hero {
    align-items: center;
    background: #f9f9f9 !important;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    height: 100%;

    &__banner {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
